<div class="layout-container">
    <div class="header">
      <img src="assets/icons/mosadad_logo.svg" alt="Mosadad Logo" class="logo" />
    </div>
  
    <div class="car-image">
      <img src="assets/car-bg.png" />
    </div>
  
</div>
<router-outlet></router-outlet> 
